export const prescripts_and_delegations = [
  {
    id: 1,
    name: "MFMA",
    summary: "shortsummary/MFMA.html",
    link: "MFMA.pdf",
    audio_en: "audio/en/MFMA_en.mp3",
    audio_af: "audio/af/MFMA_af.mp3",
    audio_xh: "audio/xh/MFMA_xh.mp3"
  },
  {
    id: 2,
    name: "PFMA",
    summary: "shortsummary/PFMA.html",
    link: "PFMA.pdf",
    audio_en: "audio/en/PFMA_en.mp3",
    audio_af: "audio/af/PFMA_af.mp3",
    audio_xh: "audio/xh/PFMA_xh.mp3"
  },
  {
    id: 3,
    name: "NIP 2050",
    summary: "shortsummary/NIP 2050.html",
    link: "NIP 2050.pdf",
    audio_en: "audio/en/NIP 2050_en.mp3",
    audio_af: "audio/af/NIP 2050_af.mp3",
    audio_xh: "audio/xh/NIP 2050_xh.mp3"
  },
  {
    id: 4,
    name: "SPLUMA",
    summary: "shortsummary/SPLUMA.html",
    link: "SPLUMA.pdf",
    audio_en: "audio/en/SPLUMA_en.mp3",
    audio_af: "audio/af/SPLUMA_af.mp3",
    audio_xh: "audio/xh/SPLUMA_xh.mp3"
  },
  {
    id: 5,
    name: "Western cape_strategic_plan_2019-2024 (PSP)",
    summary: "shortsummary/western_cape_strategic_plan_2019-2024%20(PSP).html",
    link: "PSP_western_cape_strategic_plan_2019-2024 (PSP).pdf",
    audio_en: "audio/en/WCCCRS (CCC Response Strategy)_en.mp3",
    audio_af: "audio/af/WCCCRS (CCC Response Strategy)_af.mp3",
    audio_xh: "audio/xh/WCCCRS (CCC Response Strategy)_xh.mp3"
  },
  {
    id: 6,
    name: "Growth-for-Jobs-Strategy-2023-Cabinet-Approved",
    summary: "shortsummary/Growth-for-Jobs-Strategy-2023-Cabinet-Approved.html",
    link: "Growth-for-Jobs-Strategy-2023-Cabinet-Approved.pdf",
    audio_en: "audio/en/Growth-for-Jobs-Strategy-2023-Cabinet-Approved_en.mp3",
    audio_af: "audio/af/Growth-for-Jobs-Strategy-2023-Cabinet-Approved_af.mp3",
    audio_xh: "audio/xh/Growth-for-Jobs-Strategy-2023-Cabinet-Approved_xh.mp3"
  },
  {
    id: 7,
    name: "WCIS2050 V4_Final",
    summary: "shortsummary/WCIIP_2050_v1.html",
    link: "V4 FINAL_ WCIIP 2050.pdf",
    audio_en: "audio/en/V4_FINAL_WCIIP_2050_en.mp3",
    audio_af: "audio/af/V4_FINAL_WCIIP_2050_af.mp3",
    audio_xh: "audio/xh/V4_FINAL_WCIIP_2050_xh.mp3"
  },
  {
    id: 8,
    name: "WCIS2050_v1",
    summary: "shortsummary/WCIS2050_v1.html",
    link: "WCIS2050 V4_Final.pdf",
    audio_en: "audio/en/WCIS2050_V4_Final_en.mp3",
    audio_af: "audio/af/WCIS2050_V4_Final_af.mp3",
    audio_xh: "audio/xh/WCIS2050_V4_Final_xh.mp3"
  },
  {
    id: 9,
    name: "V10 - WCIF_ 1",
    summary: "shortsummary/V10_WCIF_1.html",
    link: "V10 - WCIF_ 1.pdf",
    audio_en: "audio/en/V10_-_WCIF_1_en.mp3",
    audio_af: "audio/af/V10_-_WCIF_1_af.mp3",
    audio_xh: "audio/xh/V10_-_WCIF_1_xh.mp3"
  }
];